module.exports = __webpack_public_path__ + "img/image41.b22fa634.jpg";